import klass from './template.module.scss';
import { font } from '../../../../../services/MarppleShop/shared/typography';
import { html } from 'rune-ts';
import { html as fxjs_html } from 'fxjs/es';

// 멤버십 관련 각종 템플릿 모음
export const makeMembershipVisibleInfoHtml = ({
  visible,
  use_legacy_html,
}: {
  visible: boolean;

  /**
   * `fxjs.html` 사용할 것인지
   */
  use_legacy_html?: boolean;
}) => {
  const _html = use_legacy_html ? fxjs_html : html;

  // 다국어 지원하면 옮기기
  const text = '비공개 멤버십 플랜에 설정된 상품은 샵에서 보이지 않습니다.';

  if (!visible) {
    return _html``;
  }
  return _html`<span class="${klass.info} ${font('14_medium')}">${text}</span>`;
};
